module.exports = __webpack_public_path__ + "static/media/PRACTICA3.25cd3128.jpg";